import React from 'react';

function QuestionCardCheckboxCheckedIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <rect x="6.10352e-05" width="14" height="14" rx="2" fill="#FBB414" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.70705 6.29943C4.6148 6.20392 4.50446 6.12774 4.38245 6.07533C4.26045 6.02292 4.12923 5.99533 3.99645 5.99418C3.86367 5.99302 3.73199 6.01833 3.6091 6.06861C3.4862 6.11889 3.37455 6.19314 3.28066 6.28703C3.18676 6.38093 3.11251 6.49258 3.06223 6.61548C3.01195 6.73837 2.98665 6.87005 2.9878 7.00283C2.98895 7.13561 3.01654 7.26683 3.06895 7.38883C3.12136 7.51084 3.19754 7.62118 3.29305 7.71343L5.29305 9.71343C5.48058 9.9009 5.73489 10.0062 6.00005 10.0062C6.26521 10.0062 6.51952 9.9009 6.70705 9.71343L10.7071 5.71343C10.8026 5.62118 10.8787 5.51084 10.9312 5.38883C10.9836 5.26683 11.0111 5.13561 11.0123 5.00283C11.0135 4.87005 10.9882 4.73837 10.9379 4.61548C10.8876 4.49258 10.8133 4.38093 10.7194 4.28703C10.6256 4.19314 10.5139 4.11889 10.391 4.06861C10.2681 4.01833 10.1364 3.99302 10.0036 3.99418C9.87087 3.99533 9.73965 4.02292 9.61765 4.07533C9.49564 4.12774 9.3853 4.20392 9.29305 4.29943L6.00005 7.59243L4.70705 6.29943Z"
                fill="white"
            />
        </svg>
    );
}

export default QuestionCardCheckboxCheckedIcon;
